import axios from 'axios';
import store from '@/store';
import { getConfig } from '@/setting';
import tokenRefreshService from '@/services/tokenRefreshService';
const { hostHttpProtocol, host } = getConfig();

const axiosProxy = axios.create({
	baseURL: `${hostHttpProtocol}://${host}/api/v1`,
	timeout: API_TIMEOUT,
});

// 在 setting.js 的頂部添加
const TEST_CONFIG = {
	enabled: localStorage.getItem('test_token_refresh') === 'true',
	simulateExpiry: true
};

function requestFormat(request) {
	//params
	if (request.params) {
		//likeSearch
		let likeSearch = request.params.likeSearch;
		if (likeSearch) {
			Object.keys(likeSearch).forEach((key) => {
				if (typeof likeSearch[key] === 'string') {
					likeSearch[key] = likeSearch[key].trim() || undefined;
				}
			});
		}
	}
}
function ADD_PAGE_LOADING(type, res, value) {
	const LOADING = (
		{
			request: [res.params, res.data, res],
			response: res.config ? [
				res.config.params,
				//判斷res.config.data是否為FormData
				res.config.data instanceof FormData ? null : (res.config.data && JSON.parse(res.config.data)),
				res.config
			] : []
		}[type].find((x) => (x || {}).hasOwnProperty('LOADING')) || {}
	).LOADING;

	if (LOADING !== false) {
		store.commit('ADD_PAGE_LOADING', value);
	}
}
axiosProxy.interceptors.request.use(
	(request) => {
		ADD_PAGE_LOADING('request', request, 1);
		if (request.token !== false) {
			const token = request.hasOwnProperty('TOKEN') ? request.TOKEN : store.getters.cache.token;
			if (token) request.headers.Authorization = `Bearer ${token}`;
		}

		// 測試代碼：模擬 token 失效
		if (request.url !== '/app/auth/token/refresh' && request.url !== '/app/users/me' && TEST_CONFIG.enabled && TEST_CONFIG.simulateExpiry) {
			console.log("測試模式：模擬 token 失效");
			request.headers.Authorization = `Bearer invalid_token_for_testing`;
			// 使用一次後重置
			TEST_CONFIG.simulateExpiry = false;
		}

		if (request.domain) {
			request.baseURL = `${hostHttpProtocol}://${request.domain}/api/v1`;
		}

		//格式化處理
		requestFormat(request);

		return request;
	},
	(error) => {
		ADD_PAGE_LOADING('request', error, -1);
		return Promise.reject(error);
	}
);

axiosProxy.interceptors.response.use(
	(response) => {
		ADD_PAGE_LOADING('response', response, -1);
		if (response.data?.hasOwnProperty('status')) {
			if (!['success', 'login succeeded'].includes(response.data.status)) {
				return Promise.reject(response.data);
			}
		}
		return response.data;
	},
	async (error) => {
		ADD_PAGE_LOADING('response', error, -1);

		const originalRequest = error.config;

		// 使用 tokenRefreshService 檢查是否需要刷新 Token
		if (tokenRefreshService.shouldRefreshToken(error, originalRequest)) {
			console.log(`發現需要刷新的請求: ${originalRequest.url}`);

			// 為避免多個請求同時觸發刷新，使用 setTimeout 錯開
			await new Promise(resolve => setTimeout(resolve, Math.random() * 100));

			// 再次檢查是否已經有刷新在進行中
			if (tokenRefreshService.isRefreshing()) {
				console.log(`請求 ${originalRequest.url} 檢測到其他刷新進行中，直接進入隊列`);
				return tokenRefreshService.enqueueRequest(originalRequest, axiosProxy);
			}

			// 使用 tokenRefreshService 處理 Token 刷新，並傳遞 axiosProxy 實例
			return tokenRefreshService.handleTokenRefresh(originalRequest, axiosProxy);
		}

		return Promise.reject(error?.response?.data);
	}
);

export default axiosProxy;
